var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loggedIn
    ? _c("div", { staticClass: "redeem-gift-page" }, [
        _c(
          "div",
          {
            staticClass: "address-form-container",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("ValidationObserver", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function(ref) {
                      var handleSubmit = ref.handleSubmit
                      return [
                        _c(
                          "form",
                          {
                            attrs: { action: "*" },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-main-content" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "address-input half",
                                  attrs: {
                                    name: "First Name",
                                    rules: "required"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.address.firstName,
                                                  expression:
                                                    "address.firstName"
                                                }
                                              ],
                                              attrs: {
                                                placeholder: "First Name",
                                                type: "text"
                                              },
                                              domProps: {
                                                value: _vm.address.firstName
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.address,
                                                    "firstName",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  staticClass: "address-input half",
                                  attrs: {
                                    name: "Last Name",
                                    rules: "required"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.address.lastName,
                                                  expression: "address.lastName"
                                                }
                                              ],
                                              attrs: {
                                                placeholder: "Last Name",
                                                type: "text"
                                              },
                                              domProps: {
                                                value: _vm.address.lastName
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.address,
                                                    "lastName",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  staticClass: "address-input",
                                  attrs: { name: "Address", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.address.address,
                                                  expression: "address.address"
                                                }
                                              ],
                                              attrs: {
                                                placeholder: "Address",
                                                type: "text"
                                              },
                                              domProps: {
                                                value: _vm.address.address
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.address,
                                                    "address",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  staticClass: "address-input half",
                                  attrs: { name: "Country", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("country-select", {
                                              attrs: {
                                                whiteList: ["US", "BR"],
                                                autocomplete: true,
                                                countryName: true,
                                                country: _vm.address.country,
                                                topCountry: "US"
                                              },
                                              model: {
                                                value: _vm.address.country,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.address,
                                                    "country",
                                                    $$v
                                                  )
                                                },
                                                expression: "address.country"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  staticClass: "address-input half",
                                  attrs: { name: "State", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("region-select", {
                                              attrs: {
                                                autocomplete: true,
                                                countryName: true,
                                                regionName: true,
                                                country: _vm.address.country,
                                                region: _vm.address.state
                                              },
                                              model: {
                                                value: _vm.address.state,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.address,
                                                    "state",
                                                    $$v
                                                  )
                                                },
                                                expression: "address.state"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  staticClass: "address-input",
                                  attrs: { name: "City", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.address.city,
                                                  expression: "address.city"
                                                }
                                              ],
                                              attrs: {
                                                placeholder: "City",
                                                type: "text"
                                              },
                                              domProps: {
                                                value: _vm.address.city
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.address,
                                                    "city",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  staticClass: "address-input",
                                  attrs: {
                                    name: "Zip/Postal Code",
                                    rules: "required"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.address.zipCode,
                                                  expression: "address.zipCode"
                                                }
                                              ],
                                              attrs: {
                                                placeholder: "Zip/Postal Code",
                                                type: "text"
                                              },
                                              domProps: {
                                                value: _vm.address.zipCode
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.address,
                                                    "zipCode",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                }),
                                _vm._v(" "),
                                _c("ValidationProvider", {
                                  staticClass: "address-input",
                                  attrs: {
                                    name: "Phone Number",
                                    rules: "required"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.address.phone,
                                                  expression: "address.phone"
                                                }
                                              ],
                                              attrs: {
                                                placeholder: "Phone",
                                                type: "text"
                                              },
                                              domProps: {
                                                value: _vm.address.phone
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    _vm.address,
                                                    "phone",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", [_vm._v(_vm._s(errors[0]))])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "form-footer" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "happybox-button yellow",
                                  class: _vm.isLoading ? "isLoading" : "",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return handleSubmit(_vm.goCheckout)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.buttonText))]
                              )
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1685230185
              )
            })
          ],
          1
        )
      ])
    : _c(
        "div",
        { staticClass: "spinner-container", class: _vm.reclaimed ? "top" : "" },
        [
          _vm.invalidToken
            ? _c("p", [_vm._v("Invalid Access")])
            : _vm.reclaimed
            ? _c("div", { staticClass: "reclaimed-container" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("p", { staticClass: "subtitle" }, [
                  _vm._v("You'll receive updates and tracking info via email!")
                ])
              ])
            : _c("div", { staticClass: "loading-container" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "spinner" })
              ])
        ]
      )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-header" }, [
      _c("p", [_vm._v("Write Your Address")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      }),
      _vm._v(" "),
      _c("span", [_vm._v("Great Choice")]),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/sparkle_4a4131fa-65f2-4bcc-afa8-afb2663b6968.svg?v=1646844031"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n      If you are having trouble loading this page, please turn off your VPN or company wifi. "
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v(
        " Due to IT security restrictions, you may need to open the link on a personal device or forward the email to a personal email address to redeem your gift."
      ),
      _c("br", { staticClass: "desktop" }),
      _vm._v("\n      If you are still having issues, please reach out to "),
      _c("a", { attrs: { href: "mailto:orders@happyboxstore.com" } }, [
        _vm._v("orders@happyboxstore.com")
      ]),
      _vm._v(" for immediate assistance.\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }